<template>
	<div ref="container" class="w-full h-full relative overflow-clip">
		<slot></slot>
	</div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const container = ref(null);
const slides = ref([]);
const currentSlide = ref(0);
let rotationInterval = null;

/**
 * Apply zoom animation to the currently active image
 * Starts at scale(1) and gradually zooms to scale(1.1) over 5 seconds
 */
const applyZoomAnimation = async (img) => {
	// Reset any existing transform and transition
	img.style.transform = 'scale(1)';
	img.style.transition = 'opacity 1s ease-in-out, transform 5s ease-in';

	// Trigger zoom animation after a brief delay to ensure opacity transition starts first
	await new Promise(resolve => setTimeout(resolve, 250));
	img.style.transform = 'scale(1.1)';
};

/**
 * Reset zoom animation for the image that's being hidden
 */
const resetZoomAnimation = async (img) => {
	await new Promise(resolve => setTimeout(resolve, 1100));
	img.style.transform = 'scale(1)';
	img.style.transition = 'opacity 0.5s ease-in-out';
};

onMounted(() => {
	slides.value = Array.from(container.value.querySelectorAll('picture'));

	// Initialize first slide with zoom animation
	if (slides.value.length > 0) {
		const firstImg = slides.value[0].querySelector('img');
		firstImg.style.opacity = 1;
		applyZoomAnimation(firstImg);
	}

	rotationInterval = setInterval(() => {
		const currentImg = slides.value[currentSlide.value].querySelector('img');
		const nextSlideIndex = (currentSlide.value + 1) % slides.value.length;
		const nextImg = slides.value[nextSlideIndex].querySelector('img');

		// Fade out current image and reset its zoom
		currentImg.style.opacity = 0;
		resetZoomAnimation(currentImg);

		// Update slide index
		currentSlide.value = nextSlideIndex;

		// Fade in next image and start zoom animation
		nextImg.style.opacity = 1;
		applyZoomAnimation(nextImg);
	}, 5000);
});

onUnmounted(() => {
	if (rotationInterval) {
		clearInterval(rotationInterval);
	}
});
</script>
